import { ObstetricalFileResourcesEdinburghPostnatalDepressionScale } from "@/Patient/Components/MedicalNote/Obstetric/Form/Common/Page/Resources/Subcomponent/ObstetricalFileResourcesEdinburghPostnatalDepressionScale";
import { BaseOntarioObstetricalFileSubSection, BaseOntarioObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/Ontario/Subcomponent/BaseOntarioObstetricalFileSubSection";
import { OntarioObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/Ontario/OntarioObstetricalFileForm";

class OntarioObstetricalFileResourcesEdinburghScale extends BaseOntarioObstetricalFileSubSection<BaseOntarioObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const edinburghScale = this.props.form.Resources.PostnatalDepressionScale;
        return (
            <div className="section border">
                <ObstetricalFileResourcesEdinburghPostnatalDepressionScale<OntarioObstetricalFileForm>
                    {...this.props}
                    model={this.props.form.Resources.PostnatalDepressionScale}
                    mutatePostnatalDepressionScaleWithFormUpdate={mutation => this.props.mutateModelStateWithFormUpdate(s => mutation(s.Resources.PostnatalDepressionScale))}
                />
                <div className="row margin-md-top margin-sm-right">
                    <div className="col-md-10">
                        <p className="text-bold">{this.getString("ObstetricalFile_EdinburghScoreDescriptionLabel")}</p>
                        <span className="flex-row">
                            <p className="text-bold">{this.getString("ObstetricalFile_ScoreMoreThan9Label")}</p>
                            <p>&nbsp;{this.getString("ObstetricalFile_MinorSupportOfferLabel")}</p>
                        </span>
                        <span className="flex-row">
                            <p className="text-bold">{this.getString("ObstetricalFile_ScoreMoreThan12Label")}</p>
                            <p>&nbsp;{this.getString("ObstetricalFile_ComprehensiveBioPsychosocialLabel")}</p>
                        </span>
                    </div>
                    <div className="col-md-2">
                        <span className="text-bold margin-right-15px">{`${this.getString("TotalScoreLabel")}`}</span>
                        <span className="text-bold">{edinburghScale.totalScore ?? ""}</span>
                    </div>
                </div>
            </div>
        );
    }
}

export { OntarioObstetricalFileResourcesEdinburghScale };
